import * as React from "react";
import { Create, SimpleForm, TextInput, BooleanInput } from 'react-admin';

export const WebsiteCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <TextInput source="name" />
      <TextInput source="url" />
      <BooleanInput source="only_domain" defaultValue={false} />
    </SimpleForm>
  </Create>
);
